module.exports = "/assets/js/509053d23b7e9c1f4c3c86356038cda3.svg";